export default "__VITE_ASSET__CcjJ4R_T__"